import { useState } from "react";
import DatePicker from 'react-datepicker';

const DatePickerCustom = ({ startDate, endDate, onDateChange,handleCancel,handleApply }) => {
    // const [startDate, setStartDate] = useState(null);
    // const [endDate, setEndDate] = useState(null);

    // const handleDateChange = (update) => {
    //     setStartDate(update[0]);
    //     setEndDate(update[1]);
    // };
    
    const handleDateChange = (update) => {
        console.log("handleDateChange called with:", update); // Debugging log
        if (onDateChange) {
          onDateChange({ startDate: update[0], endDate: update[1] });
        }
      };
    return (
        <div className="wallet-transaction-repot">
            <div className="d-flex gap-2 transaction-selection-bx">
                <div><label className="text-lg font-semibold">Transaction Date</label></div>
                
                <div className="transaction-selection">
                <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => handleDateChange(update)}
                    isClearable={true}
                    className="custom-datepicker"
                    calendarClassName="custom-calendar"
                    placeholderText="Select Transaction Date"
                />
                {startDate && endDate && (
                    <div className="flex gap-2 ">
                        {/* <input
                            type="text"
                            value={startDate ? startDate.toLocaleDateString() : ''}
                            readOnly
                            className="custom-datepicker"
                            placeholder="FROM"
                        />
                        <input
                            type="text"
                            value={endDate ? endDate.toLocaleDateString() : ''}
                            readOnly
                            className="custom-datepicker"
                            placeholder="TO"
                        /> */}
                       
                        <button className="bg-gray-500 text-white px-4 py-2 rounded date-filter-apply" onClick={handleApply}>Apply</button>
                        <button className="bg-gray-300 px-4 py-2 rounded date-filter-cancel" onClick={handleCancel}>Cancel</button>
                    </div>
                    
                )}
            </div>
            </div>
        </div>);
}

export default DatePickerCustom;